import { OrderLayerPopupFundamentalData } from '@/types/order';

export const layerDataCreatorCurry = (width = 450, maxHeight = 500) => (nonFooter = true) => (id: string) => (title: string) : OrderLayerPopupFundamentalData => ({
  id,
  width,
  maxHeight,
  title,
  nonFooter,
});

export const curriedLayerDataCreator = layerDataCreatorCurry()();
export const curriedProductCouponLayer = (title: string) => curriedLayerDataCreator('productCouponLayerPopup')(title);
